
import Vue from 'vue';
export default Vue.extend({
	props: {
		lg: Boolean,
		xs: Boolean,
		sm: Boolean,
		size: [Number, String],


		// Only one of these should be set
		// inline is inline-block
		// overlay is absolute center of parent element
		// left, center, right are a block, with the spinner in the left, center or right
		// We default to 'center' if none are set.
		inline: Boolean,
		overlay: Boolean,
		left: Boolean,
		center: Boolean,
		right: Boolean,
	},
	data: () => ({ observer: null as ResizeObserver|null, }),
	computed: {
		position(): 'left'|'center'|'right'|undefined {
			if (this.left == this.right == this.center == null) return 'center';
			if (this.inline || this.overlay) return undefined;
			if (this.left) return 'left';
			if (this.right) return 'right';
			if (this.center) return 'center';
			return undefined;
		},
		classes(): any { return {lg: this.lg, sm: this.sm, overlay: this.overlay, inline: this.inline, xs: this.xs} },
		style(): any { return { fontSize: this.size ? (typeof this.size === 'number' || this.size.match(/^\d+$/)) ? this.size + 'px' : this.size : undefined,} }
	},
	mounted() {
		if (this.overlay) {
			const parent = this.$el.parentElement as HTMLElement;
			parent.style.position='relative';
			// size observer and center spinner
			this.observer = new ResizeObserver(() => {
				const {width, height} = parent.getBoundingClientRect();
				// don't use bounding client. It changes when the element rotates
				const ownWidth =  this.$el.scrollWidth;
				const ownHeight = this.$el.scrollHeight;
				const left = width / 2 - ownWidth / 2;
				const top = height / 2 - ownHeight / 2;
				// @ts-ignore
				this.$el.style.left = `${left}px`;
				// @ts-ignore
				this.$el.style.top = `${top}px`;
			});
			this.observer.observe(parent);

		}
	},
	beforeDestroy() { if (this.observer) this.observer.disconnect(); }
})
